import { CircularProgress, Flex, Text } from "@chakra-ui/react";
import { GetProgrammaticOverallViewabilityRO } from "@intentsify/dto";
import { toNumberDisplayValue } from "@intentsify/utils";
import { useQuery } from "@tanstack/react-query";
import { Card } from "components";
import { DisplayPerformanceErrorBoundary } from "../../../../DisplayPerformanceErrorBoundary";
import { DisplayPerformanceFilters } from "../../../../types";

type OverallViewabilityProps = {
  campaignId: string;
  filters: DisplayPerformanceFilters;
  getOverallViewability: (
    id: string,
    filters: DisplayPerformanceFilters
  ) => Promise<GetProgrammaticOverallViewabilityRO>;
};

const TITLE = "Overall Viewability";

const OverallViewability = (props: OverallViewabilityProps) => (
  <DisplayPerformanceErrorBoundary cardTitle={TITLE}>
    <OverallViewabilityContent {...props} />
  </DisplayPerformanceErrorBoundary>
);

const OverallViewabilityContent = ({
  campaignId,
  filters,
  getOverallViewability,
}: OverallViewabilityProps) => {
  const { data, isFetching } = useQuery(
    ["getOverallViewability", campaignId, filters],
    () => getOverallViewability(campaignId, filters)
  );

  return (
    <Card
      titleTooltip="50% of the ad unit in view for a minimum of 1 second for standard ad formats such as leaderboards and MPUs."
      isLoading={isFetching}
      title={TITLE}
      titleTooltipPlacement="bottom-end"
    >
      <Flex
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        grow={1}
      >
        <Flex minH="55px" alignItems="center" justifyContent="center">
          {data?.viewability && (
            <>
              <CircularProgress
                color="#6EB21F"
                value={data.viewability * 100}
                size={20}
                thickness={16}
                mr={4}
              />

              <Text fontSize="4xl" fontWeight="bold" lineHeight={1}>
                {toNumberDisplayValue(data.viewability * 100)}%
              </Text>
            </>
          )}
        </Flex>
      </Flex>
    </Card>
  );
};

export { OverallViewability };
